import React from "react";
import style from "./style.module.scss";
import SkeletonRow from "../../../../../components/skeleton-loader/table/row";
import { formatCurrency } from "../../../../../../components/helper/helper";

const CARD_IMAGES = {
  Visa: "/images/visa24x24.svg",
  MC: "/images/master24x24.svg",
  Discover: "/images/discover24x24.svg",
  AMEX: "/images/amex24x24.svg",
  "Pin Debit": "/images/debit24x24.svg",
  EBT: "/images/ebt24x24.svg",
};

function PlanSummary({ planSummary = {}, baseRates = [], loading }) {
  const cards = planSummary?.cards || [];
  const period = planSummary?.month || "-";

  const totalVolume = cards.reduce((acc, c) => acc + (c.volume || 0), 0);
  const totalTransactions = cards.reduce(
    (acc, c) => acc + (c.transactions || 0),
    0,
  );

  return (
    <div className={style.summary_row}>
      <div className={style.summary_card}>
        <div className={style.card_header}>
          <h5>Plan Summary</h5>
          <span className={style.period_badge}>{period}</span>
        </div>
        <div className={style.card_body}>
          <div className={style.table_container}>
            <table className={style.table}>
              <thead>
                <tr className={style.header_row}>
                  <th className={style.header_cell}>Card Brand</th>
                  <th className={style.header_cell}>Volume</th>
                  <th className={style.header_cell}>Transactions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array.from({ length: 6 }).map((_, i) => (
                    <SkeletonRow
                      key={`ps-sk-${i}`}
                      columnLength={3}
                      height="40px"
                    />
                  ))
                ) : cards.length === 0 ? (
                  <tr>
                    <td
                      colSpan="3"
                      className={style.table_cell}
                      style={{ textAlign: "center", color: "#626168" }}
                    >
                      No data
                    </td>
                  </tr>
                ) : (
                  <>
                    {cards.map((card, i) => (
                      <tr key={i} className={style.table_row}>
                        <td className={style.table_cell}>
                          <div className={style.brand_cell}>
                            {CARD_IMAGES[card.brand] && (
                              <img
                                src={CARD_IMAGES[card.brand]}
                                alt={card.brand}
                                className={style.card_icon}
                              />
                            )}
                            <span>{card.brand}</span>
                          </div>
                        </td>
                        <td className={style.table_cell}>
                          $ {formatCurrency(card.volume)}
                        </td>
                        <td className={style.table_cell}>
                          {card.transactions}
                        </td>
                      </tr>
                    ))}
                    <tr className={style.footer_row}>
                      <td className={style.footer_cell}>Total</td>
                      <td className={style.footer_cell}>
                        $ {formatCurrency(totalVolume)}
                      </td>
                      <td className={style.footer_cell}>{totalTransactions}</td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className={style.summary_card}>
        <div className={style.card_header}>
          <h5>Base Rates</h5>
        </div>
        <div className={style.card_body}>
          <div className={style.table_container}>
            <table className={style.table}>
              <thead>
                <tr className={style.header_row}>
                  <th className={style.header_cell}>Card Brand</th>
                  <th className={style.header_cell}>%</th>
                  <th className={style.header_cell}>PI</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array.from({ length: 4 }).map((_, i) => (
                    <SkeletonRow
                      key={`br-sk-${i}`}
                      columnLength={3}
                      height="40px"
                    />
                  ))
                ) : baseRates.length === 0 ? (
                  <tr>
                    <td
                      colSpan="3"
                      className={style.table_cell}
                      style={{ textAlign: "center", color: "#626168" }}
                    >
                      No data
                    </td>
                  </tr>
                ) : (
                  baseRates.map((rate, i) => (
                    <tr key={i} className={style.table_row}>
                      <td className={style.table_cell}>
                        <div className={style.brand_cell}>
                          {CARD_IMAGES[rate.brand] && (
                            <img
                              src={CARD_IMAGES[rate.brand]}
                              alt={rate.brand}
                              className={style.card_icon}
                            />
                          )}
                          <span>{rate.brand}</span>
                        </div>
                      </td>
                      <td className={style.table_cell}>
                        {rate.rate !== null ? `${rate.rate}%` : "-"}
                      </td>
                      <td className={style.table_cell}>
                        {rate.pi !== null
                          ? `$ ${formatCurrency(rate.pi)}`
                          : "-"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanSummary;
